// periods
import React from 'react';
import {
    gql, useQuery, useReactiveVar,
} from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';


const BASKET_PAGE_ROOT_QUERY_INITIAL_COPY = gql`
    query BASKET_PAGE_ROOT_QUERY_COPY_RESOLVER(
    $period: String!
) {
    cart(
        period: $period
        clear: true
    ) {
        period
        isSubscriptionActivated
        id
        typeOfSet
        haveDishesFromTrial
        isSectionsEmpty @client
        type
        sections {
            id
            title
            gift_category
            cartType
            items {
                ...ROOT_CART_DISH_ITEM
                dish {
                    ...ROOT_MENU_DISH_ITEM
                }
            }
        }
        totals {
            ...ROOT_CART_TOTAL
        }
        discount_conditions {
            ...ROOT_CART_DISCOUNT_CONDITIONS
        }
    }
}`;


// const useBasket

export const useClearBasket = (
    // query = CART_DATA_FOR_MENU_QUERY,
    query = BASKET_PAGE_ROOT_QUERY_INITIAL_COPY,
    message = 'app:hook:useBasketData',
) => {
    const period = useReactiveVar(selectedPeriodVar);

    const data = useQuery(query, {
        variables: {
            period,
        },
        context: {
            message,
        },
        fetchPolicy: 'standby',
    });
    return data.refetch;
};
